import React from 'react'
import { Layout } from 'app/theme/layout'
import { Helmet } from 'react-helmet-async'
import env from 'env'

const HEALTH_CODE_FINDER_URL = env.HEALTH_CODE_FINDER_URL

export default function HealthCodeFinderPage() {
  return (
    <Layout>
      <Helmet>
        <title>Health Code Finder | Mobile Food Alliance</title>
        <meta name="description" content="Find health code information for mobile food permits." />
      </Helmet>
      <div className="container">
        <h1 className="text-4xl md:text-5xl font-roboto-flex font-black text-navy text-center mt-8 mb-4">Instant Health Code & Permit Intelligence</h1>
        <p className="text-center text-navy text-xl font-light max-w-3xl mx-auto">
          Stop digging through dense PDFs. Our AI assistant scans local health regulations to provide clear, actionable
          answers about permits, commissaries, and equipment requirements specifically for your mobile food business.
        </p>
        <iframe
          title="Mobile Food Permit Helper - Health Code Finder"
          src={HEALTH_CODE_FINDER_URL}
          className="w-full border-0 rounded-lg"
          style={{ minHeight: 'calc(100vh - 12rem)' }}
        />
      </div>
    </Layout>
  )
}
